import {ReactNode, useEffect} from 'react';

import {useTranslation} from 'react-i18next';

import {LanguageContext} from './LanguageContext';

interface LanguageProviderProps {
  children: ReactNode;
}

export const LanguageProvider = ({children}: LanguageProviderProps) => {
  const {i18n} = useTranslation();
  const currentLanguage = i18n.resolvedLanguage as 'en' | 'de';

  useEffect(() => {
    // Set the language based on the query parameter sent in the URL from the website
    const searchParams = new URLSearchParams(window.location.search);
    const language = searchParams.get('lang');
    if (language) {
      i18n.changeLanguage(language as 'en' | 'de');
    }
  }, [i18n]);

  return <LanguageContext.Provider value={currentLanguage}>{children}</LanguageContext.Provider>;
};
